import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, t } = useI18n();
  const navigate = useNavigate();
  const location = useLocation();

  const switchTo = (nextLang) => {
    if (nextLang === lang) return;
    if (location.pathname === "/thank_you") {
      // thank-you is Croatian only, but still allow "navigation" to /nextLang home
      navigate(`/${nextLang}`);
      return;
    }
    // Save current scroll position before language switch
    const scrollY = window.scrollY;
    const parts = location.pathname.split("/").filter(Boolean);
    if (parts[0] === "hr" || parts[0] === "en") {
      parts[0] = nextLang;
    } else {
      parts.unshift(nextLang);
    }
    try {
      window.localStorage.setItem("zyravex_lang", nextLang);
      // Store scroll position temporarily for restoration after navigation
      window.sessionStorage.setItem("zyravex_scroll_restore", scrollY.toString());
    } catch (_) {}
    navigate("/" + parts.join("/") + location.search + location.hash);
  };

  return (
    <div className={`zx-lang ${compact ? "zx-lang--compact" : ""}`} role="group" aria-label={t("lang.switchTo")}>
      <button
        type="button"
        className={`zx-lang__btn ${lang === "hr" ? "is-active" : ""}`}
        onClick={() => switchTo("hr")}
        aria-pressed={lang === "hr"}
      >
        {t("lang.hr")}
      </button>
      <span className="zx-lang__sep" aria-hidden="true">/</span>
      <button
        type="button"
        className={`zx-lang__btn ${lang === "en" ? "is-active" : ""}`}
        onClick={() => switchTo("en")}
        aria-pressed={lang === "en"}
      >
        {t("lang.en")}
      </button>
    </div>
  );
}
